import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider'

(() => {
    const homeSlider = document.querySelector('.home-hero-slider')

    if(homeSlider) {
        const TNS = tns({
            container: homeSlider,
            nav: false,
            mouseDrag: true,
            controlsContainer: '.home-hero-controls',

        })
    }
})()
